// Resit tempahan bercetak (berjenama). Boleh dicetak atau disimpan sebagai PDF melalui pelayar.
import { html, mount } from '../core/html.js';
import { get, session } from '../core/api.js';
import { icon } from '../core/ui.js';
import { fmtDate, fmtTs } from '../core/format.js';
import { t } from '../core/i18n.js';
import { breakdownRows } from './property.js';

export async function render(main, { id }) {
  const { booking: b } = await get(`/api/bookings/${id}`);
  const s = session.config.settings;
  const name = s.platform_name;
  const pay = b.payment_information;
  const paid = b.payment_status === 'PAID' || !!pay;
  const guest = b.snapshot.guest_information || {};
  const nights = b.pricing?.nights || b.nights;

  mount(main, html`<div class="wrap receipt-page">
    <div class="receipt-actions">
      <a class="btn btn-ghost btn-sm" href="#/bookings/${b.id}">${t('receipt.back')}</a>
      <button class="btn btn-primary btn-sm" id="print" type="button">${icon('printer')}${t('receipt.print')}</button>
    </div>
    <article class="receipt" aria-labelledby="rtitle">
      <div class="accent"></div>
      <header class="rhead">
        <img src="/brand/logo-horizontal.png" alt="${name}" width="212" height="54">
        <div class="doc">
          <h1 id="rtitle">${t('receipt.title')}</h1>
          <div>${t('receipt.number')} <b translate="no">R-${b.id}</b></div>
          <div>${t('receipt.issued')}: ${fmtTs(pay?.paid_at || b.created_at, false)}</div>
        </div>
      </header>
      <div class="rbody">
        <div class="spread">
          <span class="paid ${paid ? '' : 'no'}">${icon(paid ? 'check' : 'generic')}${paid ? t('receipt.paid') : t('receipt.unpaid')}</span>
          ${pay && !pay.livemode ? html`<span class="status warn">${t('receipt.test')}</span>` : ''}
        </div>
        <div class="parties">
          <div><div class="lbl">${t('receipt.billed_to')}</div><b data-ugc>${guest.name || ''}</b>${guest.email ? html`<div class="small" translate="no">${guest.email}</div>` : ''}${guest.phone ? html`<div class="small" translate="no">${guest.phone}</div>` : ''}</div>
          <div><div class="lbl">${t('receipt.stay')}</div><b data-ugc>${b.snapshot.property_name}</b>${b.snapshot.property_address ? html`<div class="small">${b.snapshot.property_address}</div>` : ''}<div class="small">${t('receipt.host')}: <span data-ugc>${b.snapshot.host_name}</span></div></div>
          <div><div class="lbl">${t('receipt.dates')}</div><b>${fmtDate(b.check_in)} – ${fmtDate(b.check_out)}</b>${nights ? html`<div class="small">${t('receipt.nights', { n: nights })}, ${t('common.people', { n: b.guests })}</div>` : ''}</div>
          ${pay ? html`<div><div class="lbl">${t('receipt.payment')}</div><b>${t(`gateway.${pay.gateway}`)}</b><div class="small">${t('receipt.reference')}: <span translate="no">${pay.transaction_ref || pay.payment_id}</span></div></div>` : ''}
        </div>
        <div>${breakdownRows(b.pricing)}</div>
      </div>
      <footer class="rfoot"><span>${t('receipt.note', { name })}</span>${s.support_email ? html`<span>${t('receipt.contact', { email: s.support_email })}</span>` : ''}</footer>
    </article>
  </div>`);
  main.querySelector('#print').onclick = () => window.print();
}
